module.exports = __webpack_public_path__ + "img/sport-77-@3x.e55e09d9.png";